module.exports = __webpack_public_path__ + "img/title_pic.ce4eb5d8.png";